module.exports = __webpack_public_path__ + "img/Millionaire-6.60b26f3d.png";